import { render, staticRenderFns } from "./PhoneRolePromptDialog.vue?vue&type=template&id=13652db8&scoped=true"
import script from "./PhoneRolePromptDialog.vue?vue&type=script&lang=js"
export * from "./PhoneRolePromptDialog.vue?vue&type=script&lang=js"
import style0 from "./PhoneRolePromptDialog.vue?vue&type=style&index=0&id=13652db8&prod&lang=css"
import style1 from "./PhoneRolePromptDialog.vue?vue&type=style&index=1&id=13652db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13652db8",
  null
  
)

export default component.exports